import { render, staticRenderFns } from "./GroupRequestPanel.vue?vue&type=template&id=0af3ed7e&scoped=true"
import script from "./GroupRequestPanel.vue?vue&type=script&lang=js"
export * from "./GroupRequestPanel.vue?vue&type=script&lang=js"
import style0 from "./GroupRequestPanel.vue?vue&type=style&index=0&id=0af3ed7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3ed7e",
  null
  
)

export default component.exports